import React from "react";
import {
	Box,
	Button,
	Typography,
} from "@mui/material";
import { TextFieldControl } from "@haohan/form-ui"
import { useForm } from "react-hook-form"

import { AuthForgotPasswordFormSuccess } from "./Success";
import { SiteRouterLink } from "../../../../components/RouterLink";
import { useI18n } from "../locales";
import { papi } from "@haohan-frontend/papi";
import { useUrlWithNext } from "../../../utils";

export function AuthForgotPasswordForm() {
	const [ success, setSuccess ] = React.useState(false);
	const { t, Trans } = useI18n();
	const { control, formState, getValues, handleSubmit } = useForm({
		defaultValues: {
			email: '',
		},
		mode: 'onTouched',
	});
	const submitForm = handleSubmit(async (data: {email: string}) => {
		await papi.auth.forgotPassword(data);
		setSuccess(true);
	});
	const loginURL = useUrlWithNext('/auth/login');
	return (
		<Box position='relative'>
			{success && (
				<AuthForgotPasswordFormSuccess email={getValues().email || 'asdsadsa@dsadsa.dasom'}/>
			)}
			<form onSubmit={submitForm}>
				<TextFieldControl
					autoComplete='username'
					control={control}
					fullWidth
					inputMode='email'
					label='Email'
					margin='dense'
					name='email'
					rules={{
						required: t('errors.Required field'),
						pattern: {
							value: /\S+@\S+\.\S{2,}/,
							message: t('errors.email_invalid')
						},
					}}
					size='small'
					variant='outlined'
				/>

				<Box mt={5}>
					<Button
						disabled={formState.isSubmitting}
						fullWidth
						type='submit'
						variant='contained'
					>
						{t('actions.Reset password')}
					</Button>
				</Box>
				<Box textAlign='center' mt={1}>
					<Typography variant='body2' color='textSecondary'>
						<Trans
							i18nKey="actions.Go back to <0>Login screen</0>"
							components={[
								<SiteRouterLink
									to={loginURL}
									underline='hover'
									variant='body2'
								/>
							]}
						/>
					</Typography>
				</Box>
			</form>
		</Box>
	);
}
